// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-date-picker-input input {
  border: 1px solid #ffffff;
  box-shadow: none !important;
}
.custom-date-picker-input .form-control {
  border: 1px solid #ffffff;
  box-shadow: none !important;
}
.custom-date-picker-input .form-control.ng-invalid.ng-dirty {
  border-color: #ff0000;
  outline-color: #ff0000;
}
`, "",{"version":3,"sources":["webpack://./src/js/lib/DateSelector/dateSelector.less"],"names":[],"mappings":"AACA;EAEQ,yBAAA;EACA,2BAAA;AADR;AAFA;EAOQ,yBAAA;EACA,2BAAA;AAFR;AAGQ;EACI,qBAAA;EACA,sBAAA;AADZ","sourcesContent":["\n.custom-date-picker-input {\n    input {\n        border: 1px solid #ffffff;\n        box-shadow: none !important;\n    }\n\n    .form-control {\n        border: 1px solid #ffffff;\n        box-shadow: none !important;\n        &.ng-invalid.ng-dirty {\n            border-color: #ff0000;\n            outline-color: #ff0000;\n          }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
